<template>
    <div class="ProfileBox">
        <h2>{{ this.risorse["StoricoOrdini"] }}</h2>
        <HistoryTable :count="-1"/>
    </div>
</template>

<script>

import HistoryTable from '@/components/Historytable.vue'
import {risorseMixin} from "@/mixin.js";

export default {
    name: "StoricoOrdini",
    components: {
        HistoryTable
    },
    mixins:[risorseMixin] 
}
</script>